$(document).ready(function() {
  (function() {
    function Product(id, title, image, url, category) {
      this.id = id;
      this.title = title;
      this.image = image;
      this.url = url;
      this.category = category;
    }

    const productsComparision = {
      products: [],
      limit: 5,
      isButtonMarked: false,

      addText: "Compare",
      localStorageKey: "products_comparision",
      addedText: "Remove",

      category: null,
      container: $("#products-comparision"),
      productsButtons: $(".products-comparision-add-button"),
      productTemplate: $("#products-comparision-template"),
      productsContainer: $("#products-comparision-products"),
      compareButton: $("#products-comparision-compare"),
      resetButton: $("#products-comparision-reset"),
      lengthContainer: $("#products-comparision__length"),
      limitContainer: $("#products-comparision__limit"),

      init() {
        if ($("#products-comparision").length === 0) {
          return;
        }

        this.products = this.loadFromLocalStorage();
        if (this.products.length) {
          this.category = this.products[0].category;
          this.markButtonsFromDifferentCategory(this.category);
        }

        productsComparision.changeLength();
        $("body").on("click", $(".products-comparision-add-button"), function(
          e
        ) {
          if ($(event.target).hasClass("products-comparision-add-button")) {
            productsComparision.addProductToComparision(e);
          }
        });
        this.limitContainer.text(this.limit);

        this.products.forEach(product => {
          this.renderProductInBar(product);
          productsComparision.switchButtonToAdded(product);
        });

        if (this.products.length > 0) {
          $("#products-comparision").show();
        }

        this.compareButton.on("click", event => {
          let products = [];
          let link = $(event.target).attr("data-href");

          this.products.forEach(product => {
            products.push(product.id);
          });

          window.location.href = link + "?products=" + products.join(",");
        });

        this.resetButton.on("click", event => {
          this.products.forEach(product => {
            productsComparision.deleteProductFromList(product);
          });

          this.setProducts([]);
          productsComparision.container.hide();
        });
      },

      loadFromLocalStorage() {
        let products = localStorage.getItem(
          productsComparision.localStorageKey
        );

        products = products !== null ? JSON.parse(products) : [];

        return products;
      },

      changeLength() {
        productsComparision.lengthContainer.text(
          productsComparision.products.length
        );
      },

      addProduct(product) {
        productsComparision.products.push(product);
        productsComparision.changeLength();
        localStorage.setItem(
          productsComparision.localStorageKey,
          JSON.stringify(productsComparision.products)
        );
      },

      setProducts(products) {
        productsComparision.products = products;
        productsComparision.changeLength();
        localStorage.setItem(
          productsComparision.localStorageKey,
          JSON.stringify(products)
        );
      },

      removeProduct(product) {
        let div = $(`.products-comparision__product[data-id="${product.id}"]`);

        div.remove();
      },

      addProductToComparision(event) {
        let target = $(event.target);

        if (
          target.attr("data-on-list") !== "true" &&
          productsComparision.products.length >= productsComparision.limit
        ) {
          console.log("Limit reached");

          return false;
        }

        let product = new Product(
          target.attr("data-id"),
          target.attr("data-title"),
          target.attr("data-image"),
          target.attr("data-url"),
          target.attr("data-category")
        );

        if (productsComparision.category) {
          if (productsComparision.category !== product.category) {
            return;
          }
        } else {
          productsComparision.category = product.category;
        }

        if (target.attr("data-on-list") === "true") {
          productsComparision.setProducts(
            productsComparision.products.filter(e => e.id !== product.id)
          );
          productsComparision.switchButtonToAdd(product);
          productsComparision.removeProduct(product);
          productsComparision.products.length === 0 &&
            productsComparision.container.hide();

          if (productsComparision.products.length === 0) {
            productsComparision.category = null;
            productsComparision.removeButtonToDifferent(product);
            productsComparision.isButtonMarked = false;
          }
        } else {
          productsComparision.addProduct(product);
          productsComparision.renderProductInBar(product);
          productsComparision.switchButtonToAdded(product);
          productsComparision.container.show();
        }

        this.markButtonsFromDifferentCategory(this.category);
      },

      markButtonsFromDifferentCategory(category) {
        if (productsComparision.isButtonMarked) {
          return;
        }

        if (!category) {
          return;
        }

        const $buttons = $(`.products-comparision-add-button`).not(
          `[data-category='${category}']`
        );

        if (!$buttons.length) {
          return;
        }

        $buttons
          .children(".products-comparison-label--add")
          .removeClass("active");

        $buttons
          .children(".products-comparison-label--remove")
          .removeClass("active");

        $buttons
          .children(".products-comparison-label--different")
          .addClass("active");

        productsComparision.isButtonMarked = true;
      },

      removeButtonToDifferent(product) {
        if ($(".products-comparison-label--different").hasClass("active")) {
          $(".products-comparison-label--different").removeClass("active");
          $(".products-comparison-label--different")
            .siblings(".products-comparison-label--add")
            .addClass("active");
        }
      },

      switchButtonToAdded(product) {
        let button = $(
          `.products-comparision-add-button[data-id="${product.id}"]`
        );

        button
          .children(".products-comparison-label--add")
          .removeClass("active");
        button
          .children(".products-comparison-label--remove")
          .addClass("active");

        if (
          button
            .children(".products-comparison-label--different")
            .hasClass("active")
        ) {
          button
            .children(".products-comparison-label--different")
            .removeClass("active");
        }

        button.attr("data-on-list", true);
      },

      switchButtonToAdd(product) {
        let button = $(
          `.products-comparision-add-button[data-id="${product.id}"]`
        );

        button
          .children(".products-comparison-label--remove")
          .removeClass("active");
        button.children(".products-comparison-label--add").addClass("active");

        if (
          button
            .children(".products-comparison-label--different")
            .hasClass("active")
        ) {
          button
            .children(".products-comparison-label--different")
            .removeClass("active");
        }

        button.attr("data-on-list", false);
      },

      renderProductInBar(product) {
        let productDiv = productsComparision.productTemplate
          .find("div.products-comparision__product")
          .clone();

        productDiv.html(
          productDiv
            .html()
            .replace("(image)", `src="${product.image}"`)
            .replace("(url)", `href="${product.url}"`)
            .replace("(id)", product.id)
        );
        productDiv
          .attr("data-id", product.id)
          .attr("data-category", product.category);
        productDiv.appendTo(productsComparision.productsContainer);

        let products = $(".products-comparision__product-delete");

        products.each(index => {
          $(products[index]).on("click", this.deleteFromList);
        });
      },

      deleteFromList(event) {
        let target = $(event.target);
        let product = new Product(target.attr("data-id"), null, null, null);

        productsComparision.deleteProductFromList(product);
      },

      deleteProductFromList(product) {
        productsComparision.setProducts(
          productsComparision.products.filter(e => e.id !== product.id)
        );
        productsComparision.switchButtonToAdd(product);
        productsComparision.removeProduct(product);
        productsComparision.products.length === 0 &&
          productsComparision.container.hide();
        if (productsComparision.products.length === 0) {
          productsComparision.category = null;
          productsComparision.removeButtonToDifferent(product);
          productsComparision.isButtonMarked = false;
        }
      }
    };

    productsComparision.init();
  })();
});
